import React, { useEffect, useState } from "react";
import { SetShopsArea } from "../components/master";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton } from "../components/UIkit";
import { saveShops } from "../reducks/shops/operations";
import { getShops } from "../reducks/shops/selectors";

const ShopsEdit = () => {
  const dispatch = useDispatch();
  const shopsOnFirestore = useSelector(getShops);
  const [shops, setShops] = useState(shopsOnFirestore);
  return (
    <section>
      <h2 className="u-text__headline u-text-center">販売店の登録・編集</h2>
      <div className="c-section-container">
        <SetShopsArea shops={shops} setShops={setShops} />
      </div>
      <div className="module-spacer--small" />
      <div className="center">
        <PrimaryButton
          label={"上書き保存"}
          onClick={() => dispatch(saveShops(shops))}
        />
      </div>
    </section>
  );
};

export default ShopsEdit;
